import type { Template } from "@/types";

export const SQ_03_H1_V2: Template[] = [
    {
        id: "sq-03-h1v2-01",
        name: "SQ 01 - H1V2",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-03-h1_v2_01.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 91, y: 138, width: 295, height: 442, rotation: 0, imageRotation: 0 },
            { id: "2", x: 394, y: 138, width: 649, height: 442, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1052, y: 138, width: 295, height: 442, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "sq-03-h1v2-02",
        name: "SQ 02 - H1V2",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-03-h1_v2_02.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 62, y: 117, width: 324, height: 485, rotation: 0, imageRotation: 0 },
            { id: "2", x: 394, y: 117, width: 649, height: 485, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1051, y: 117, width: 324, height: 485, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "sq-03-h1v2-03",
        name: "SQ 03 - H1V2",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-03-h1_v2_03.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 47, y: 117, width: 646, height: 485, rotation: 0, imageRotation: 0 },
            { id: "2", x: 744, y: 117, width: 323, height: 485, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1074, y: 117, width: 323, height: 485, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "sq-03-h1v2-04",
        name: "SQ 04 - H1V2",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-03-h1_v2_04.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 108, y: 191, width: 500, height: 334, rotation: 0, imageRotation: 0 },
            { id: "2", x: 744, y: 117, width: 323, height: 485, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1074, y: 117, width: 323, height: 485, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "sq-03-h1v2-05",
        name: "SQ 05 - H1V2",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-03-h1_v2_05.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 134, y: 77, width: 976, height: 580, rotation: 0, imageRotation: 0 },
            { id: "2", x: 1118, y: 77, width: 189, height: 286, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1118, y: 371, width: 189, height: 286, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "sq-03-h1v2-06",
        name: "SQ 06 - H1V2",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-03-h1_v2_06.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 45, y: 131, width: 627, height: 457, rotation: 0, imageRotation: 0 },
            { id: "2", x: 847, y: 189, width: 225, height: 341, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1080, y: 189, width: 225, height: 341, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-03-h1v2-07",
        name: "SQ 07 - H1V2",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-03-h1_v2_07.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 45, y: 131, width: 627, height: 457, rotation: 0, imageRotation: 0 },
            { id: "2", x: 847, y: 131, width: 225, height: 341, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1080, y: 247, width: 225, height: 341, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-03-h1v2-08",
        name: "SQ 08 - H1V2",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-03-h1_v2_08.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 67, y: 131, width: 686, height: 457, rotation: 0, imageRotation: 0 },
            { id: "2", x: 761, y: 131, width: 301, height: 457, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1070, y: 131, width: 301, height: 457, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-03-h1v2-09",
        name: "SQ 09 - H1V2",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-03-h1_v2_09.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 137, y: 212, width: 443, height: 297, rotation: 0, imageRotation: 0 },
            { id: "2", x: 766, y: 129, width: 305, height: 462, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1079, y: 129, width: 305, height: 462, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-03-h1v2-10",
        name: "SQ 10 - H1V2",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-03-h1_v2_10.png",
        size: [1434, 717],
        style: {},
        slots: [        
            { id: "1", x: 51, y: 0, width: 240, height: 355, rotation: 0, imageRotation: 0 },
            { id: "2", x: 51, y: 363, width: 240, height: 354, rotation: 0, imageRotation: 0 },
            { id: "3", x: 298, y: 0, width: 1084, height: 717, rotation: 0, imageRotation: 0 },
        ],
    },


];


  


